export default __webpack_public_path__ + "static/icon-0ab08a2e7452932f9d8c96894760f6c4.png";